import { useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import SmartLink from "../fragments/SmartLink";
import Image from "../fragments/Image";
import { useReveal } from '../hooks/UseReveal';

import "swiper/css";
import "swiper/css/navigation";

import Accreditation from "../fragments/Accreditation";
import SpecialText from "../fragments/SpecialText";

export default function Accreditations({ block }) {

	const swiperRef = useRef(null);
	const revealRef = useReveal({ once: true });

	if (!block || !block.slides || block.slides.length === 0) return null;

	return (
		<div id={block.section_id} className="c-page__block c-page__block--accreditations">
			<div className="c-accreditations">
				<div className="l-grid c-transition-in" ref={revealRef}>
					<div className="l-grid__col">
						<h2 className="c-accreditations__heading c-heading">
							<SpecialText text={block.heading || 'Accreditations'} />
						</h2>
					</div>
					<div className="l-grid__col">
						<Swiper
							modules={[Navigation]}
							navigation={true}
							slidesPerView={1}
							spaceBetween={16}
							breakpoints={{
								640: {
									slidesPerView: 2,
									spaceBetween: 24,
								},
								1280: {
									slidesPerView: 3,
									spaceBetween: 28,
								},
							}}
							grabCursor={true}
							onSwiper={(s) => (swiperRef.current = s)}
							className="c-accreditations__swiper"
						>
							{block.slides.map((slide, index) => {
								
								return (
									<SwiperSlide key={index}>
										<Accreditation accreditation={slide} />
									</SwiperSlide>
								);
							})}
						</Swiper>
					</div>
				</div>
			</div>
		</div>
	);
} 